export const EntityType = {
    MENTION: 'MENTION',
    CREATE_MENTION: 'CREATE_MENTION',
}
